import { seCeCopy } from './seCe';
import { veeqoCopy } from './veeqo';

export const copy = {
  seCe: seCeCopy,
  veeqo: veeqoCopy,
};
